import { useNavigate } from "react-router-dom"
import { Grid, Typography } from "@mui/material"
import { ISettingsItem, useSettings } from "../../Settings"
import { useTranslation } from "../../i18n"

export default function FooterNavigation({ name }: ISettingsItem) {
  const navigate = useNavigate()
  const { socials, externalPages } = useSettings()
  const { pageTitle } = useSettings()
  const { t } = useTranslation()

  const navButtons = [
    { label: `${t.footer.aboutPrefix} ${pageTitle?.toUpperCase()}`, link: externalPages?.about },
    { label: t.footer.askDoubts, link: `https://wa.me/${socials?.whatsapp}` },
    { label: t.footer.lgpd, link: externalPages?.lgpd },
    { label: t.footer.contact, link: `https://wa.me/${socials?.whatsapp}` }
  ]

  return (
    <Grid item className={name ? `${name} footer-navigation` : "footer-navigation"}>
      {navButtons
        .filter(({ link }) => link && link.trim() !== "")
        .map(({ link, label }, index) => (
          <Typography
            key={index}
            variant="body2"
            component="a"
            rel="noopener noreferrer"
            aria-label={`social-link-${index}`}
            {...link === '/' ? {
              onClick: () => {
                navigate('/')
                window.scrollTo({ top: 0, behavior: 'smooth' })
              }
            } : {
              target: "_blank",
              href: link
            }}
            sx={{ cursor: 'pointer' }}
          >
            {label}
          </Typography>
      ))}
    </Grid>
  )
}